import script from "./GuestInformation2.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestInformation2.vue?vue&type=script&setup=true&lang=js"

import "./GuestInformation2.vue?vue&type=style&index=0&id=3057fb2c&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3057fb2c"]])

export default __exports__